export default [
  {
    path: '/data-informasi',
    redirect: '/data-informasi',
    name: 'dataInformasi',
    component: () => import('@/views/NestedRoute.vue'),
    children: [
      {
        path: '',
        name: 'dataInformasiIndex',
        component: () => import('@/views/dataInformasi/Index.vue'),
        meta: {
          action: 'Lihat',
          resource: 'dataInformasi',
          pageTitle: 'Data Informasi',
          breadcrumb: [
            {
              text: 'Data Informasi',
              active: true,
            },
          ],
        },
      },
      {
        path: '/data-informasi/input/:id',
        name: 'dataInformasiTambah',
        component: () => import('@/views/dataInformasi/Tambah.vue'),
        meta: {
          action: 'Buat',
          resource: 'dataInformasi',
          pageTitle: 'Data Informasi',
          breadcrumb: [
            {
              text: 'Data Informasi',
            },
            {
              text: 'Input',
              active: true,
            },
          ],
        },
        props: true,
      },
      {
        path: '/data-informasi/validasi/:id',
        name: 'dataInformasiValidasi',
        component: () => import('@/views/dataInformasi/Validasi.vue'),
        meta: {
          action: 'Validasi',
          resource: 'dataInformasi',
          pageTitle: 'Validasi Data Informasi',
          breadcrumb: [
            {
              text: 'Validasi Keberadaan',
            },
            {
              text: 'Validasi',
              active: true,
            },
          ],
        },
        props: true
      },
      {
        path: '/data-informasi/detail/:id',
        name: 'dataInformasiDetail',
        component: () => import('@/views/dataInformasi/Validasi.vue'),
        meta: {
          action: 'Detail',
          resource: 'dataInformasi',
          pageTitle: 'Detail Data Informasi',
          breadcrumb: [
            {
              text: 'Detail Keberadaan',
            },
            {
              text: 'Detail',
              active: true,
            },
          ],
        },
        props: true
      },
    ]
  }
]